import { z } from 'zod'
import { formatCurrency } from '@/lib/utils'
import { parsearImporte } from './facturaManualSchema'

/** Nota de crédito por una parte de la factura (ORR-255 fase C). `saldo` es lo que queda por acreditar. */
export const notaCreditoParcialSchema = (saldo: number) =>
  z.object({
    importe: z
      .string()
      .refine((s) => parsearImporte(s) > 0, 'Importe inválido')
      .refine((s) => !(parsearImporte(s) > saldo), `Queda ${formatCurrency(saldo)} por acreditar`),
    concepto: z.string().trim().min(1, 'Falta el concepto').max(200, 'Hasta 200 caracteres'),
    enviarEmail: z.boolean(),
  })

export type NotaCreditoParcialFormValues = z.infer<ReturnType<typeof notaCreditoParcialSchema>>

export const DEFAULT_NOTA_CREDITO_PARCIAL: NotaCreditoParcialFormValues = { importe: '', concepto: '', enviarEmail: true }
